import { makeStyles } from '@mui/styles';

import { globalTheme as theme } from '@styles';

export const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: theme.palette.brandDarkBlue.main,
    color: theme.palette.common.white,
    fontSize: '12px',
    padding: theme.spacing(2),
    lineHeight: 1.5,
    fontWeight: 400,
  },

  arrow: {
    color: theme.palette.brandDarkBlue.main,
  },
}));
